export default __webpack_public_path__ + "ea7c6d4a1808088cad96cddaceca2739.svg";